import {
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V1,
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V2,
  type RecommendationServiceType,
} from '../../recommendation/config'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../model/Experiment.types'

export const pdpAvailableRecommendationGetRequestParams = ({
  currentServiceId,
  experiment,
  isEligible,
  isProdrecEnabledAndV2,
}: {
  currentServiceId: RecommendationServiceType
  experiment: ExperimentType
  isEligible: boolean
  isProdrecEnabledAndV2: boolean
}): {
  prodrec?: true
  serviceId: RecommendationServiceType
} => {
  if (!isEligible || !experiment.isEnabled) {
    return { serviceId: currentServiceId }
  }

  if (isProdrecEnabledAndV2) {
    return {
      prodrec: true,
      serviceId: RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V2,
    }
  }

  if (experiment.variant === EXPERIMENT_VARIATION.V1) {
    return { serviceId: RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V1 }
  }

  return { serviceId: currentServiceId }
}
